import { isBrowser } from "@shared/utils.environment";
import { v4 as uuidv4 } from "uuid";

export function getInitialAnonId(): string | undefined {
  if (isBrowser()) {
    const anonIdStr = window.localStorage.getItem("anonId") ?? null;
    if (!anonIdStr) {
      const uuid = uuidv4();
      window.localStorage.setItem("anonId", uuid);
      return uuid;
    }
    return anonIdStr;
  }
  return undefined;
}
